import {isServiceInOtherSection, isServiceInSuccessNetwork} from "./serviceUtils";

export function InstitutionalService(service) {
  return {
    ...service,
    get inServiceCatalog() {
      return service.serviceCategories.indexOf('serviceCatalog') !== -1
    },

    get inSuccessNetwork() {
      return isServiceInSuccessNetwork(service)
    },

    // An "other" service is in the service catalog but *not* in the success network.
    get isOtherService() {
      return isServiceInOtherSection(service)
    }
  }
}
